import React from "react";
import ProductItem from "./index";
import PropTypes from 'prop-types'

const ProductItemCollection = (props) => {
  const { data } = props;
  // if(!Array.isArray(data) || (Array.isArray(data) && data.length < 1)){
  //   return null;
  // }
  return (
    <div className="home-product-carousel owl-carousel owl-theme">
      {data.map((item, i) => {
        return (
          <div key={i}>
            <ProductItem
              image={item.image}
              price={item.price}
              title={item.title}
              url={item.url}
            />
          </div>
        );
      })}
    </div>
  );
};

ProductItem.propTypes = {    
  url : PropTypes.string,
  image : PropTypes.string,
  price :  PropTypes.string,
  title : PropTypes.string,
}
export default ProductItemCollection;
